module.exports = __webpack_public_path__ + "static/media/14UNEP16.ec21c4e1.jpg";